import { filterActionTypes } from './filter.types';

// Carregar filtro selecionado do localStorage na inicialização
const getInitialSelectedFilter = () => {
  try {
    const savedFilter = localStorage.getItem('selectedFilter');
    return savedFilter ? JSON.parse(savedFilter) : null;
  } catch (error) {
    console.error('Erro ao carregar filtro do localStorage:', error);
    return null;
  }
};

const initialState = {
  filters: [],
  selectedFilter: getInitialSelectedFilter(),
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case filterActionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    case filterActionTypes.SET_SELECTED_FILTER:
      // Salvar filtro selecionado no localStorage
      try {
        if (action.payload) {
          localStorage.setItem('selectedFilter', JSON.stringify(action.payload));
        } else {
          localStorage.removeItem('selectedFilter');
        }
      } catch (error) {
        console.error('Erro ao salvar filtro no localStorage:', error);
      }
      
      return {
        ...state,
        selectedFilter: action.payload,
      };

    default:
      return state;
  }
}

export default filterReducer;
